var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"text-center"},[_c('div',{staticClass:"py-4"},[(_vm.blobData)?_c('a',{staticClass:"btn btn-primary btn-lg",on:{"click":_vm.download}},[_vm._v("Download")]):_vm._e()]),_vm._l((_vm.pagesCount),function(i){return _c('pdf',{key:i,staticStyle:{"display":"inline-block","width":"80%"},attrs:{"src":_vm.src,"page":i}})})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }